// ============================================================================
//  autoColors — automatyczne kolory stref przy zmianie rozmiaru/modelu
//  (uwaga klienta 25.08.2026): wybieg niebieski, trumna czerwona, kort
//  czerwony — a w presecie „Mały" kort niebieski. Automat działa per strefa,
//  dopóki użytkownik sam nie wybierze jej koloru (flagi colorAuto w stanie
//  main.js) — ręczny wybór ma zawsze pierwszeństwo.
//  Palety różnią się nazwami odcieni per model (tiles.json), więc id dobieramy
//  z listy preferencji; paleta bez pasującej barwy (E630 nie ma czerwonego)
//  → null = koloru nie zmieniamy. Czysty moduł — testowalny pod Node.
// ============================================================================

const IDS = {
  red: ['brick-red', 'cherry-red', 'red'],
  blue: ['navy', 'trinidad-blue', 'sky-blue', 'blue'],
  // Fallback kortu przy palecie bez czerwieni (E630): jasnoniebieski.
  'light-blue': ['sky-blue', 'light-blue'],
}

export function autoZoneColorId(palette, kind) {
  const wanted = IDS[kind] || []
  const id = wanted.find((w) => palette.some((p) => p.id === w))
  return id ?? null
}
